import { useState } from "react";
import { Text } from "@fluentui/react/lib/Text";
import customTheme from "helpers/customTheme";
import { IPublishedTemplate } from "models/templates";

interface TemplateListProps {
  templates: IPublishedTemplate[];
  onTemplateSelect?: (template: IPublishedTemplate | null) => void;
}

function TemplateList({ templates, onTemplateSelect }: TemplateListProps) {
  const [selectedTemplate, setSelectedTemplate] = useState<string | null>(null);

  const handleTemplateSelect = (template: IPublishedTemplate) => {
    const newSelection = selectedTemplate === template.key ? null : template.key;
    setSelectedTemplate(newSelection);
    const selectedTemplateObj = newSelection ? template : null;
    onTemplateSelect?.(selectedTemplateObj);
  };

  if (templates.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "40px 20px" }}>
        <Text variant="medium" styles={{ root: { color: customTheme.bodySubText } }}>
          No templates found
        </Text>
      </div>
    );
  }

  return (
    <div style={{ 
      padding: "0",
      marginTop: "16px",
      height: "100%",
    }}>
      <div style={{
        backgroundColor: "white",
        height: "100%",
      }}>
        {templates.map((template) => (
          <div
            key={template.key}
            role="button"
            tabIndex={0}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "12px 16px",
              cursor: "pointer",
              transition: "background-color 0.15s ease",
            }}
            onClick={() => handleTemplateSelect(template)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleTemplateSelect(template);
              }
            }}
            onMouseEnter={(e) => {
              if (selectedTemplate !== template.key) {
                e.currentTarget.style.backgroundColor = customTheme.menuItemBgHovered;
              }
            }}
            onMouseLeave={(e) => {
              if (selectedTemplate !== template.key) {
                e.currentTarget.style.backgroundColor = "transparent";
              }
            }}
          >
            <input
              type="radio"
              name="templateSelection"
              value={template.key}
              checked={selectedTemplate === template.key}
              onChange={() => setSelectedTemplate(template.key)}
              style={{ 
                marginRight: "12px",
                cursor: "pointer",
                transform: "scale(1.1)",
              }}
            />
            <Text
              variant="medium"
              styles={{
                root: {
                  fontWeight: 400,
                  color: customTheme.bodyColor,
                  cursor: "pointer",
                  lineHeight: "20px",
                },
              }}
            >
              {template.name}
            </Text>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TemplateList;